// Build the persisted `client.summary` rollup from the analyzed workforce.
// Used by:
//   - BulkView (mirrors into currentClient on every employees/analyzed change)
//   - ClientDetailDrawer SmartCensusUpload onUploaded (after backend persist)
//   - CensusUploadStep (employer portal)
//
// Keeps the dashboard, dropdown counts, and Update-Client modal in sync with
// the live workforce computation regardless of which upload path was used.

import { optimizeEmployeeWithEligibility } from './calculations';

export function buildClientSummary(analyzed) {
  const t = {
    totalEmployees: 0,
    eligible: 0,
    ineligible: 0,
    ineligible_1099: 0,
    ineligible_hours: 0,
    ineligible_owner: 0,
    ineligible_union: 0,
    ineligible_salary: 0,
    waiting: 0,
    annualEmployerFica: 0,
    annualEmployeeBenefit: 0,
    annualHcRevenue: 0,
  };
  if (!Array.isArray(analyzed) || analyzed.length === 0) return t;

  for (const e of analyzed) {
    t.totalEmployees++;
    if (e.eligibility) {
      if (e.eligibility.eligible && e.hasViable && e.optimal) {
        t.eligible++;
        t.annualEmployerFica   += e.optimal.employerAnnualFica   || 0;
        t.annualEmployeeBenefit += e.optimal.employeeAnnualBenefit || 0;
        t.annualHcRevenue      += e.optimal.hcAnnualRevenue       || 0;
      } else if (e.eligibility.status === 'waiting') {
        t.waiting++;
      } else if (e.eligibility.status === '1099')   { t.ineligible++; t.ineligible_1099++; }
      else if (e.eligibility.status === 'hours')    { t.ineligible++; t.ineligible_hours++; }
      else if (e.eligibility.status === 'owner')    { t.ineligible++; t.ineligible_owner++; }
      else if (e.eligibility.status === 'union')    { t.ineligible++; t.ineligible_union++; }
      else if (e.eligibility.status === 'salary')   { t.ineligible++; t.ineligible_salary++; }
    } else if (e.hasViable && e.optimal) {
      // Legacy data-shape path (no eligibility object)
      t.eligible++;
      t.annualEmployerFica   += e.optimal.employerAnnualFica   || 0;
      t.annualEmployeeBenefit += e.optimal.employeeAnnualBenefit || 0;
      t.annualHcRevenue      += e.optimal.hcAnnualRevenue       || 0;
    } else {
      t.ineligible++;
      t.ineligible_salary++;
    }
  }
  return t;
}

// Convenience: takes raw `employees` (post-parse) + a config and returns the
// summary by running optimizeEmployeeWithEligibility per row. Used by upload
// paths that don't already have an `analyzed` array (e.g. drawer + portal
// smart-upload onUploaded).
export function buildClientSummaryFromEmployees(employees, config) {
  if (!Array.isArray(employees) || employees.length === 0 || !config) {
    return buildClientSummary([]);
  }
  const analyzed = employees.map((emp) => optimizeEmployeeWithEligibility(emp, config));
  return buildClientSummary(analyzed);
}
